import { render, staticRenderFns } from "./CinemaClass.vue?vue&type=template&id=1d396145&scoped=true"
import script from "./CinemaClass.vue?vue&type=script&lang=js"
export * from "./CinemaClass.vue?vue&type=script&lang=js"
import style0 from "./CinemaClass.vue?vue&type=style&index=0&id=1d396145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d396145",
  null
  
)

export default component.exports